import { render, staticRenderFns } from "./list_categories_component.vue?vue&type=template&id=3c2042e2&scoped=true"
import script from "./list_categories_component.vue?vue&type=script&lang=js"
export * from "./list_categories_component.vue?vue&type=script&lang=js"
import style0 from "./list_categories_component.vue?vue&type=style&index=0&id=3c2042e2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2042e2",
  null
  
)

export default component.exports